// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.targets {
  margin-left: 14%;
  margin-top: 20px;
}

.targets h3 {
  color: #3a4469;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 0;
}

.targets .target-btn {
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  background-color: #060d27;
  color: #ffffff;
  font-size: 12px;
  margin-top: auto;
  padding: 10px 20px;
}

.targets .circle-progress {
  height: 100px;
  width: 100px;
}

.targets .circle-progress .CircularProgressbar .CircularProgressbar-trail {
  stroke: #d9d9d9;
  stroke-width: 4;
}

.targets .engagements .CircularProgressbar .CircularProgressbar-path {
  stroke: #00b56f;
  stroke-width: 6;
}

.targets .accomplished-task .CircularProgressbar .CircularProgressbar-path {
  stroke: #f5c000;
  stroke-width: 6;
}

.targets .circle-progress .CircularProgressbar .CircularProgressbar-text {
  font-weight: 600;
  font-size: 24px;
}

.targets .engagements .CircularProgressbar .CircularProgressbar-text {
  fill: #00b56f;
}

.targets .accomplished-task .CircularProgressbar .CircularProgressbar-text {
  fill: #f5c000;
}

.targets .section-heading {
  background-color: #c6c6c64b;
  font-size: 14px;
  padding: 15px 10px;
  color: #002e5b;
  font-weight: 600;
}

.targets section {
  margin-top: 40px;
}

.targets .table {
  background-color: transparent;
  border-color: transparent;
}

.targets .progress {
  background-color: #ededed;
  height: 10px;
  width: 90%;
  margin-right: 10px;
}

.targets .progress-bar {
  width: 50%;
  height: 10px;
  background-color: #2323e5;
  border-radius: 8px;
}

.targets .custom-select {
  width: 120px;
}

.target-form .custom-select {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/target/Targets.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".targets {\n  margin-left: 14%;\n  margin-top: 20px;\n}\n\n.targets h3 {\n  color: #3a4469;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.targets .target-btn {\n  border: 1px solid #d6d6d6;\n  border-radius: 4px;\n  background-color: #060d27;\n  color: #ffffff;\n  font-size: 12px;\n  margin-top: auto;\n  padding: 10px 20px;\n}\n\n.targets .circle-progress {\n  height: 100px;\n  width: 100px;\n}\n\n.targets .circle-progress .CircularProgressbar .CircularProgressbar-trail {\n  stroke: #d9d9d9;\n  stroke-width: 4;\n}\n\n.targets .engagements .CircularProgressbar .CircularProgressbar-path {\n  stroke: #00b56f;\n  stroke-width: 6;\n}\n\n.targets .accomplished-task .CircularProgressbar .CircularProgressbar-path {\n  stroke: #f5c000;\n  stroke-width: 6;\n}\n\n.targets .circle-progress .CircularProgressbar .CircularProgressbar-text {\n  font-weight: 600;\n  font-size: 24px;\n}\n\n.targets .engagements .CircularProgressbar .CircularProgressbar-text {\n  fill: #00b56f;\n}\n\n.targets .accomplished-task .CircularProgressbar .CircularProgressbar-text {\n  fill: #f5c000;\n}\n\n.targets .section-heading {\n  background-color: #c6c6c64b;\n  font-size: 14px;\n  padding: 15px 10px;\n  color: #002e5b;\n  font-weight: 600;\n}\n\n.targets section {\n  margin-top: 40px;\n}\n\n.targets .table {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.targets .progress {\n  background-color: #ededed;\n  height: 10px;\n  width: 90%;\n  margin-right: 10px;\n}\n\n.targets .progress-bar {\n  width: 50%;\n  height: 10px;\n  background-color: #2323e5;\n  border-radius: 8px;\n}\n\n.targets .custom-select {\n  width: 120px;\n}\n\n.target-form .custom-select {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
